const state = {
  lang: localStorage.getItem("lang") || ""
};

const getters = {
  appLang: state => !!state.lang,
  currentLang: state => state.lang
};

const mutations = {
  SET_LANG: (state, lang) => {
    state.lang = lang;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}